import PaginationButton from 'components/orders/PaginationButton/styled';

export default PaginationButton;
